import { Injectable } from '@angular/core';
import { ApplicationTemplateRequest } from '../../models/application-template-form-model';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { FormGroupType } from '../../../../../../core/models/form-group-type';
import { StringValidators } from '../../../../../../core/validators/string-validators/string-validators';
import { ApplicationTemplateExistsRequest } from '../../models/application-template-exists-request';
import { ApplicationTemplateService } from '../../../../shared/services/application-template/application-template.service';
import { take, tap } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class ApplicationTemplateFormService {
    constructor(
        private readonly applicationTemplateService: ApplicationTemplateService,
    ) {}

    /**
     * Creates a form group for the application template request.
     */
    getTemplateForm(): FormGroup<FormGroupType<ApplicationTemplateRequest>> {
        return new FormGroup<FormGroupType<ApplicationTemplateRequest>>({
            name: new FormControl<string>('', [
                Validators.required,
                StringValidators.noWhitespace,
            ]),
            description: new FormControl<string | null>(null),
            shouldOverwrite: new FormControl<boolean>(false),
        });
    }

    /**
     * Checks if the template name already exists and updates the form control accordingly.
     * @param form The form group containing the template name control.
     * @param request The request object containing the template name to check.
     */
    checkTemplateNameExistence(
        form: FormGroup<FormGroupType<ApplicationTemplateRequest>>,
        request: ApplicationTemplateExistsRequest,
    ): void {
        this.applicationTemplateService
            .exists(request)
            .pipe(
                take(1),
                tap((exists) => {
                    form.controls.shouldOverwrite.patchValue(exists);
                }),
            )
            .subscribe();
    }
}
